import { ContentChipColor } from 'ComponentLibrary/src/piazza/content/ContentChip/ContentChip'

export type DocumentTagOption = { title: string; color: ContentChipColor }

export const germanTagOptions: DocumentTagOption[] = [
    { title: 'Altlasten', color: 'royal' },
    { title: 'Amtlicher Lageplan', color: 'blue' },
    { title: 'Aufteilungsplan', color: 'turquoise' },
    { title: 'Auskunft aus Abt.2', color: 'leaf' },
    { title: 'Baubeschreibung', color: 'green' },
    { title: 'Baulasten', color: 'lime' },
    { title: 'Baugenehmigung', color: 'green' },
    { title: 'Bebauungsplan', color: 'blue' },
    { title: 'CapEx', color: 'orange' },
    { title: 'Denkmalschutz', color: 'royal' },
    { title: 'Eintragungsbewilligung', color: 'leaf' },
    { title: 'Energieausweis', color: 'green' },
    { title: 'Erschließungskosten', color: 'lime' },
    { title: 'Flächenberechnung', color: 'turquoise' },
    { title: 'Flächennutzungsplan', color: 'blue' },
    { title: 'Flurbereinigung', color: 'lime' },
    { title: 'Grundbuchauszug', color: 'leaf' },
    { title: 'Grundrisse', color: 'turquoise' },
    { title: 'Katasterauszug', color: 'blue' },
    { title: 'Mieterliste', color: 'orange' },
    { title: 'Mietverträge', color: 'orange' },
    { title: 'Sanierungsgebiet', color: 'royal' },
    { title: 'Städtebauliche Satzungen', color: 'red' },
    { title: 'Teilungserklärung', color: 'red' },
]

export const englishTagOptions: DocumentTagOption[] = [
    { title: 'Contaminated sites', color: 'royal' },
    { title: 'Official site plan', color: 'blue' },
    { title: 'Partition plan', color: 'turquoise' },
    { title: 'Section II extract', color: 'leaf' },
    { title: 'Building description', color: 'green' },
    { title: 'Building encumbrances', color: 'lime' },
    { title: 'Building permit', color: 'green' },
    { title: 'Development plan', color: 'blue' },
    { title: 'CapEx', color: 'orange' },
    { title: 'Monument protection', color: 'royal' },
    { title: 'Registration approval', color: 'leaf' },
    { title: 'Energy certificate', color: 'green' },
    { title: 'Development costs', color: 'lime' },
    { title: 'Area calculation', color: 'turquoise' },
    { title: 'Land use plan', color: 'blue' },
    { title: 'Land readjustment', color: 'lime' },
    { title: 'Land register extract', color: 'leaf' },
    { title: 'Floor plans', color: 'turquoise' },
    { title: 'Cadastral extract', color: 'blue' },
    { title: 'Tenant list', color: 'orange' },
    { title: 'Rental agreements', color: 'orange' },
    { title: 'Redevelopment area', color: 'royal' },
    { title: 'Urban development statutes', color: 'red' },
    { title: 'Declaration of division', color: 'red' },
]

export const tagOptions = germanTagOptions

export function getLocalizedDocumentTagOptions(locale?: string): DocumentTagOption[] {
    return locale?.toLowerCase().startsWith('en') ? englishTagOptions : germanTagOptions
}

function getSupportedTagIndex(tagTitle: string) {
    const germanTagIndex = germanTagOptions.findIndex((tagOption) => tagOption.title === tagTitle)
    if (germanTagIndex >= 0) {
        return germanTagIndex
    }

    return englishTagOptions.findIndex((tagOption) => tagOption.title === tagTitle)
}

export function localizeSupportedDocumentTags(tagTitles: string[], locale?: string): DocumentTagOption[] {
    const localizedTagOptions = getLocalizedDocumentTagOptions(locale)

    return tagTitles.map((tagTitle) => {
        const supportedTagIndex = getSupportedTagIndex(tagTitle)
        if (supportedTagIndex < 0) {
            return {
                title: tagTitle,
                color: 'grey',
            }
        }

        return localizedTagOptions[supportedTagIndex]
    })
}
